import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {classMap} from 'lit/directives/class-map.js';
import {checkbox} from './sp-checkbox.styles';
import {SpBaseInput} from "../sp-base-input";
import {DirectiveResult} from "lit/directive";
import {TemplateResult} from "lit-html";

@customElement('sp-checkbox')
export class SpCheckbox extends SpBaseInput<boolean> {
    @property({type: String})
    label: string | DirectiveResult | TemplateResult;
    @property({type: Boolean, reflect: true})
    checked = false;
    @property({type: Boolean, reflect: true})
    disabled = false;
    @property({type: String})
    variant: 'default' | 'minimal' = 'default';

    get value() {
        return this.checked;
    }
    set value(value: boolean) {
        this.checked = value
    }

    static styles =[
        checkbox
    ];

    protected render() {
        return html`
            <a
                class=${classMap({
                    checked: this.checked,
                    disabled: this.disabled,
                    minimal: this.variant === 'minimal'
                })}
                @click=${this.check}>
                <span></span>${this.label}
            </a>
        `;
    }

    private check($event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (!this.disabled) {
            this.value = !this.value;
            this.emit<SpCheckboxChangePayload>('change', { detail: { checked: this.checked} })
        }
    }
}

export interface SpCheckboxChangePayload {
    checked: boolean
}
